module.exports = __webpack_public_path__ + "69a2d762bbcca6068e5813ffaf10084e.png";